import { ListService } from "@/common/api.service";
import { FETCH_DIRECTORY, FETCH_DIRECTORIES } from "./actions.type";

const state = {
  directory: {
    status: [],
    program_fin_support: [],
    org_form: [],
    regions: [],
    tree_industry: [],
    code_okpd: [],
    sp_monogorod: [],
    country: [],
    tree_sp_infoproduction: [],
    list_import_plan: [],
    product_plan_import: [],
    start_pokazatel: [],
    tree_vid_financing_other_sources: [],
    procuring: [],
    tree_zalogi: [],
    type_face_zalog: [],
    sp_vid_oblegacii: [],
    vid_transport: [],
    dop_procuring: [],
    tree_group_cifra_oborudovanie: [],
    tree_group_med_oborudovanie: [],
    type_source_lizing_budget: [],
    source_information: [],
    tree_vid_prom_products: [],
    tree_file_type2: [],
    ir_sp: [],
    plan_istochnik_sp: [],
    status_expertise: [],
    type_address: [],
    high_tehnology_sp: [],
    sp_high_technology_mpt1863: [],
    sp_list_actual_technology: [],
    status_all: [],
    type_present: [],
    type_suspension_sp: [],
    type_terminate_sp: [],
    sp_ndt: [],
    type_project: [],
    export_endition: [],
    country_export: [],
    country_rus_first: [],
    reg_fond_list: [],
    departaments: [],
    vid_procuring: [],
    vid_zalog: [],
    tree_budget_article: [],
    tree_vid_financing_other_sources_old: [],
    sp_is_valid_pp: [],
    sp_criteria_financial_stability: [],
    sp_products_in_special_territories: [],
    type_making: [],
    sp_status_group_orgs: [],
    type_provision_sp: [],
    marker_products: [],
    sp_federal_project: [],
    sp_vid_doc_dz: [],
    tree_sp_type_doc_dz: [],
    hl_dz_accept_electronic_view: [],
    hl_dz_accept_paper_view: [],
    sp_duration_expertise: [],
    sp_variant_zalog_expertise: [],
    type_expertise_fie: [],
    sp_vid_type_product_list_id: [],
    sp_type_productions: [],
    sp_list_critical_component_mvk: [],
    sp_time_status_set_expertise: [],
    sp_project_products_list: [],
    sp_project_products_mobilization_list: [],
    sp_list_of_products_zaim_markirovka: [],
    hl_request_status: [],
    hl_request_type: [],
    sp_expertise_type_fie: [],
    sp_expertise_type_pre: [],
    sp_expert_sovet_type: [],
    sp_question_expert_sovet_type: [],
    sp_vid_result_intellectual_rid: [],
    sp_financial_indicator_org: [],
    sp_priority_components_auto: [],
    sp_direction_financing: [],
    sp_confirmation_part_national_project: [],
    sp_purchased_equipment_lizing: [],
    sp_purchased_equipment_lizing_zaklucheniya: [],
    sp_departament_project: [],
    sp_types_loans: [],
    sp_source_financing: [],
    tree_sp_orders_high_tech_industry: [],
    sp_list_priority_products_formed_mvk: [],
    sp_list_national_projects: [],
    sp_list_products_nacional_projects: [],
    sp_purchased_equipment_lizing_heavy: [],
    sp_project_okpd_products: [],
    tree_sp_categories_of_purchased_equipment: [],
    sp_purchased_ship_lizing: [],
    sp_lizing_ship_payment_period: []
  }
};

const getters = {
  directory() {
    return state.directory;
  },
  DStatus(state) {
    return state.directory.status;
  },
  DRegions(state) {
    return state.directory.regions;
  },
  DProgramFinSupport(state) {
    return state.directory.program_fin_support;
  },
  DOrgForm(state) {
    return state.directory.org_form;
  },
  DTypeProvision(state) {
    return state.directory.type_provision_sp;
  },
  DtypeOfExpertise(state) {
    return state.directory.sp_duration_expertise;
  },
  DtypeZalogExpertise(state) {
    return state.directory.sp_variant_zalog_expertise;
  },
  DtypeloanZaim(state) {
    return state.directory.sp_types_loans;
  }
};

const actions = {
  [FETCH_DIRECTORY]({ state }, r, force = false) {
    let rw = r[0].replace("/", "_");
    if (!force && state.directory[rw].length > 0) {
      return;
    }
    return ListService.list(r)
      .then(({ data }) => {
        state.directory[rw] = data;
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  [FETCH_DIRECTORIES]({ state }, rs = [], force = false) {
    return Promise.all(
      rs.map(function(r) {
        let rw = r.replace("/", "_");
        if (!force && state.directory[rw].length > 0) {
          return null;
        }
        return ListService.list(r)
          .then(({ data }) => {
            state.directory[rw] = data;
          })
          .catch(error => {
            throw new Error(error);
          });
      })
    );
  }
};

export default {
  state,
  getters,
  actions
};
